// Module
var code = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M6.00002 7.0377L0.346191 1.3839L1.40002 0.330078L6.00002 4.93008L10.6 0.330078L11.6538 1.3839L6.00002 7.0377Z\" fill=\"#1C1B1F\"/> </svg> ";
// Exports
module.exports = code;